module.exports = __webpack_public_path__ + "static/media/40.bb89ca92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/40.jpg
// module id = 409
// module chunks = 0